import { render, staticRenderFns } from "./ProtectMeasures.vue?vue&type=template&id=a6cb6068&scoped=true&"
import script from "./ProtectMeasures.vue?vue&type=script&lang=js&"
export * from "./ProtectMeasures.vue?vue&type=script&lang=js&"
import style0 from "./ProtectMeasures.vue?vue&type=style&index=0&id=a6cb6068&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a6cb6068",
  null
  
)

export default component.exports